import Vue from 'vue';
import VueI18n from 'vue-i18n';

import enApp from './en.json';
import esApp from './es.json';
import caApp from './ca.json';

const en = { ...enApp };
const es = { ...esApp };
const ca = { ...caApp };

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'es',
	fallbackLocale: 'es',
	silentFallbackWarn: true,
	messages: { en: en, es: es, ca: ca }
});
